import { render } from "./ModalTechIssue.vue?vue&type=template&id=32b7732f&scoped=true"
import script from "./ModalTechIssue.vue?vue&type=script&lang=js"
export * from "./ModalTechIssue.vue?vue&type=script&lang=js"

import "./ModalTechIssue.vue?vue&type=style&index=0&id=32b7732f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b7732f"]])

export default __exports__